export default __webpack_public_path__ + "static/media/ic_aave_24.f4f3a0a0.svg";